import { useContextSelector } from "use-context-selector"
import { KeyboardNavigationContext } from "./KeyboardNavigationProvider.react"

export const useIsKeyboardNavigationActive = () =>
  useContextSelector(
    KeyboardNavigationContext,
    ctx => ctx.keyboardNavigationActive,
  )
